export const ASSETS = {
  logo: "https://customer-assets-wrfwihn1.emergentagent.net/job_8368c542-502d-4e68-9dbe-8d723bb6238e/artifacts/gw0eutjy_6a8e62c7-572f-43bc-82b9-ce31119b5ffe.jpeg",
  founder: "https://customer-assets-jai6qajn.emergentagent.net/job_yuva-jan-party/artifacts/1qsgupgi_IMG_8722.jpeg",
  cofounder: "https://customer-assets-jai6qajn.emergentagent.net/job_yuva-jan-party/artifacts/1516mggh_4b43cba0-5fb8-47fc-a2d0-a1a80b341724_9406AE8F-4EAC-4B32-A41F-02363D4C4F0F.jpeg",
  campaign: "https://images.unsplash.com/photo-1737391583708-70750a8559c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHxfHxpbmRpYW4lMjB5b3V0aCUyMHJhbGx5JTIwY3Jvd2R8ZW58MHx8fDE3OTEyMTk4MTV8MA&ixlib=rb-4.1.0&q=85",
  campus: "https://images.unsplash.com/photo-1501503069356-3c6b82a17d89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjB1bml2ZXJzaXR5JTIwY29sbGVnZSUyMHN0dWRlbnRzJTIwbGlicmFyeSUyMGVkdWNhdGlvbnxlbnwwfHx8fDE3OTEyMTk4MTh8MA&ixlib=rb-4.1.0&q=85"
};

export const COPY = {
  hi: {
    party: "युवा जननीति पार्टी",
    nav: ["परिचय", "संकल्प", "अभियान"],
    join: "साथ जुड़ें",
    languageToggle: "EN",
    heroKicker: "नई पीढ़ी • नया लोकतंत्र • YJP",
    heroTitle: ["युवा आवाज़,", "भारत का भविष्य"],
    heroText: "सरकारें आएंगी जाएंगी, पार्टियां बनेंगी बिगड़ेंगी — लेकिन यह देश रहना चाहिए। इस देश का लोकतंत्र रहना चाहिए।",
    heroMeta: "कैंपस से सदन तक • जनभागीदारी का मोर्चा",
    manifesto: "हमारा संकल्प",
    marquee: ["देश रहना चाहिए", "लोकतंत्र रहना चाहिए", "युवा आगे आएंगे", "शिक्षा · रोज़गार · छात्र-राजनीति"],
    about: "हम कौन हैं",
    aboutTitle: ["हम सत्ता के लिए नहीं,", "समाज के लिए राजनीति करते हैं।"],
    aboutLead: "युवा जननीति पार्टी एक जनांदोलन है — उन युवाओं का जो सवाल पूछते हैं, भागीदारी चाहते हैं और भारत के भविष्य को खुद गढ़ना चाहते हैं।",
    aboutText: "हमारा विश्वास है कि लोकतंत्र सिर्फ चुनाव का दिन नहीं, बल्कि रोज़मर्रा की सक्रिय नागरिकता है।",
    stats: [["01", "जनांदोलन"], ["03", "प्रमुख संकल्प"], ["24×7", "नागरिक भागीदारी"]],
    founder: "संस्थापक",
    founderTitle: ["एक विचार से", "एक आंदोलन तक।"],
    founderText: "युवा जननीति पार्टी के संस्थापक — एक ऐसे भारत के लिए प्रतिबद्ध, जहाँ युवा सिर्फ दर्शक नहीं, लोकतंत्र के सक्रिय निर्माता हों।",
    founderQuote: "जहाँ युवा आगे आता है, वहाँ भविष्य रास्ता बदलता है।",
    founderRole: "संस्थापक • YJP",
    cofounder: "सह-संस्थापक",
    cofounderName: "आकर्ष सिंह",
    cofounderTitle: ["मिलकर गढ़ा", "एक संगठन।"],
    cofounderText: "आकर्ष सिंह — युवा जननीति पार्टी के सह-संस्थापक, जो संगठन के विस्तार, युवा जुड़ाव और जमीनी अभियानों को दिशा देते हैं।",
    cofounderQuote: "संगठन ही सबसे बड़ी ताक़त है।",
    cofounderRole: "सह-संस्थापक • YJP",
    ideals: "पार्टी के आदर्श",
    idealsTitle: ["जिन विचारों से", "हम दिशा लेते हैं।"],
    idealsNote: "दो प्रधानमंत्री, एक साझा मूल्य — लोकतंत्र पहले।",
    idealCards: [
      ["AB", "अटल बिहारी वाजपेयी", "भारत के पूर्व प्रधानमंत्री", "संवाद की राजनीति, सहमति की क्षमता और राष्ट्र-प्रथम निष्ठा — YJP की विचारधारा को वाजपेयी जी के मार्मिक और लोकतांत्रिक नेतृत्व से प्रेरणा मिलती है।"],
      ["CS", "चंद्र शेखर", "भारत के पूर्व प्रधानमंत्री", "निडर आवाज़, जमीनी संघर्ष और सामाजिक न्याय के लिए प्रतिबद्धता — चंद्र शेखर जी की राजनीति युवाओं को सत्ता से सवाल पूछने का साहस देती है।"]
    ],
    sankalpTitle: ["तीन वादे।", "एक नई दिशा।"],
    sankalpNote: "युवा भारत के लिए",
    pillars: [
      ["01", "मुफ्त शिक्षा", "हर युवा को गुणवत्तापूर्ण शिक्षा और सीखने के समान अवसर।", "book"],
      ["02", "प्रगतिशील रोज़गार", "कौशल, उद्यम और सम्मानजनक रोजगार के लिए नई दिशा।", "work"],
      ["03", "छात्र राजनीति की वापसी", "कॉलेज और विश्वविद्यालय में छात्रों की लोकतांत्रिक भागीदारी।", "students"]
    ],
    bentoImageTitle: "कैंपस ही लोकतंत्र की पहली कक्षा है।",
    bentoQuote: "शिक्षा मुफ्त, काम सम्मानजनक, और आवाज़ ताक़तवर।",
    campaigns: "जनभागीदारी से बदलाव",
    campaignTitle: ["आपकी आवाज़", "आपकी भूमिका"],
    campaignText: "बदलाव किसी एक नेता से नहीं आता। वह तब आता है जब लाखों युवा अपने मोहल्ले, कैंपस और शहर में आगे आते हैं।",
    formTitle: "बदलाव का हिस्सा बनिए",
    formSub: "अपनी जानकारी साझा करें और YJP के साथ अपने शहर से शुरुआत करें।",
    fields: ["पूरा नाम", "मोबाइल नंबर", "ईमेल", "शहर"],
    submit: "स्वयंसेवक बनें",
    success: "धन्यवाद! हमारी टीम आपसे जल्द संपर्क करेगी।",
    error: "कृपया दोबारा प्रयास करें।",
    footerText: "देश रहना चाहिए। लोकतंत्र रहना चाहिए।",
    footerTag: "भारत के युवाओं के लिए, भारत के युवाओं द्वारा"
  },
  en: {
    party: "Yuva Janniyon Party",
    nav: ["About", "Sankalp", "Campaigns"],
    join: "Join the movement",
    languageToggle: "हिं",
    heroKicker: "A new generation • A new democracy • YJP",
    heroTitle: ["Youth voices,", "India's future"],
    heroText: "Governments will come and go, parties will rise and fall — but this country must endure. Its democracy must endure.",
    heroMeta: "Campus to Parliament • A front for participation",
    manifesto: "Our Sankalp",
    marquee: ["The nation must endure", "Democracy must endure", "Youth will step forward", "Education · Work · Student politics"],
    about: "Who we are",
    aboutTitle: ["We do not do politics", "for power, but for society."],
    aboutLead: "Yuva Janniyon Party is a people's movement — led by young people who ask questions, seek participation and want to shape India's future themselves.",
    aboutText: "We believe democracy is not just election day, but active citizenship every day.",
    stats: [["01", "People's movement"], ["03", "Core pledges"], ["24×7", "Civic participation"]],
    founder: "Founder",
    founderTitle: ["From one idea", "to a movement."],
    founderText: "Founder of Yuva Janniyon Party — committed to an India where young people are not spectators, but active makers of democracy.",
    founderQuote: "Where youth step forward, the future changes course.",
    founderRole: "Founder • YJP",
    cofounder: "Co-Founder",
    cofounderName: "Aakarsh Singh",
    cofounderTitle: ["Built together,", "one organisation."],
    cofounderText: "Aakarsh Singh — Co-Founder of Yuva Janniyon Party, guiding organisational growth, youth outreach and grassroots campaigns.",
    cofounderQuote: "The organisation is our greatest strength.",
    cofounderRole: "Co-Founder • YJP",
    ideals: "Party ideals",
    idealsTitle: ["The ideas", "that set our course."],
    idealsNote: "Two prime ministers, one shared value — democracy first.",
    idealCards: [
      ["AB", "Atal Bihari Vajpayee", "Former Prime Minister of India", "Politics of dialogue, the strength of consensus and nation-first commitment — YJP draws inspiration from Vajpayee ji's humane and democratic leadership."],
      ["CS", "Chandra Shekhar", "Former Prime Minister of India", "A fearless voice, grassroots struggle and commitment to social justice — Chandra Shekhar ji's politics gives young people the courage to question power."]
    ],
    sankalpTitle: ["Three promises.", "One new direction."],
    sankalpNote: "For a young India",
    pillars: [
      ["01", "Free education", "Quality education and equal opportunities to learn for every young person.", "book"],
      ["02", "Progressive employment", "A new direction for skills, enterprise and dignified work.", "work"],
      ["03", "Student politics, restarted", "Democratic participation for students in colleges and universities.", "students"]
    ],
    bentoImageTitle: "Campus is democracy's first classroom.",
    bentoQuote: "Free education, dignified work, and a louder public voice.",
    campaigns: "Change through participation",
    campaignTitle: ["Your voice.", "Your role."],
    campaignText: "Change does not come from one leader. It comes when millions of young people step up in their neighbourhoods, campuses and cities.",
    formTitle: "Be part of the change",
    formSub: "Share your details and begin from your city with YJP.",
    fields: ["Full name", "Mobile number", "Email", "City"],
    submit: "Become a volunteer",
    success: "Thank you! Our team will reach out to you soon.",
    error: "Please try again.",
    footerText: "The nation must endure. Democracy must endure.",
    footerTag: "For India's youth, by India's youth"
  }
};
